import React, { useEffect, useRef } from 'react';
import '../css/PartnersSection.css'; 
import coingecko from '../assets/coingecko.png';
import coinpaprika from '../assets/coinpaprika.png';
import xeggex from '../assets/xeggex.png';
import tradeogre from '../assets/tradeogre.png';
import whattomine from '../assets/whattomine.png';
import hashrate from '../assets/hashrate.png';
import miningpoolstats from '../assets/miningpoolstats.png';

const InfiniteLooper = ({ children }) => {
    const looperRef = useRef(null);

    useEffect(() => {
        const looper = looperRef.current;

        // Clone the children to ensure a seamless loop
        const clonedChildren = looper.innerHTML;
        looper.innerHTML += clonedChildren;

        let scrollAmount = 0;
        const speed = 0.5;

        const scroll = () => {
            scrollAmount -= speed;
            if (Math.abs(scrollAmount) >= looper.scrollWidth / 2) {
                scrollAmount = 0;
            }
            looper.style.transform = `translateX(${scrollAmount}px)`;
            requestAnimationFrame(scroll);
        };

        scroll(); // Start the scroll animation
    }, []);

    return (
        <div className="looper-container">
            <div className="looper" ref={looperRef}>
                {children}
            </div>
        </div>
    );
};

const PartnersSection = () => {
    const partners = [
        { name: "Coingecko", link: "https://www.coingecko.com/en/coins/ai-depin", image: coingecko },
        { name: "Coinpaprika", link: "https://coinpaprika.com/coin/aidp-aidp/", image: coinpaprika },
        { name: "Xeggex", link: "https://xeggex.com/market/AIDP_USDT", image: xeggex },
        { name: "TradeOgre", link: "https://tradeogre.com/exchange/AIDP-USDT", image: tradeogre },
        { name: "WhatToMine", link: "https://whattomine.com/coins/416-aidp-kawpow", image: whattomine },
        { name: "Hashrate", link: "https://www.hashrate.no/coins/AIDP", image: hashrate },
        { name: "Mining Pool Stats", link: "https://miningpoolstats.stream/aidepin", image: miningpoolstats },
    ];

    return (
        <section id="partners-section" className="partners-section">
            <h2>Our Partners</h2>
            <h3>Explore our key partners and the websites that promote us!</h3>
            <InfiniteLooper>
                {partners.map((partner) => (
                    <div className="contentBlock contentBlock--one" key={partner.name}>
                        <a href={partner.link} target="_blank" rel="noopener noreferrer">
                            <img src={partner.image} alt={partner.name} style={{ height: 'auto' }} />
                        </a>
                    </div>
                ))}
            </InfiniteLooper>
        </section>
    );
};

export default PartnersSection;
